<template>
  <b-container fluid>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color: #2284ab">Status</h5>
      </div>
      <div class="body-content">
        <b-card body>
          <b-tabs card v-model="tabIndex">
            <!-- <b-tab title="Principal Employer" key="01" active>
                <StgApplicationEmployerMap v-if="applicationId" :ExemptionApplicationId="applicationId" @clicked="show2()"></StgApplicationEmployerMap>
               </b-tab> -->

            <!-- <b-tab title="Guard" key="02" active> 
                <StgApplicationGuardMap v-if="applicationId" :ExemptionApplicationId="applicationId" @clicked="show3()"></StgApplicationGuardMap>
               </b-tab>     -->

            <b-tab title="Registartion" key="03" active>
              <RegisterStgApplication
                v-if="applicationId"
                :ExemptionApplicationId="applicationId"
                :ApplicationDetails="ApplicationDetails"
              ></RegisterStgApplication>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </b-container>
</template>

<script>
import StgApplicationEmployerMap from "@/components/AgencyExemption/StgApplicationEmployerMap";
import StgApplicationGuardMap from "@/components/AgencyExemption/StgApplicationGuardMap";
import RegisterStgApplication from "@/components/AgencyExemption/RegisterStgApplication";
export default {
  components: {
    StgApplicationEmployerMap,
    StgApplicationGuardMap,
    RegisterStgApplication,
  },
  computed: {
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log (x);
      return x;
    },
  },
  data() {
    return {
      tabIndex: 0,
      showPg2: false,
      showPg3: false,
      applicationId: "",
      ApplicationDetails: [],
    };
  },
  methods: {
    show2() {
      this.showPg2 = true;
      this.tabIndex = 1;
    },
    show3() {
      this.showPg3 = true;
      this.tabIndex = 2;
    },
  },
  mounted() {
    // console.log(this.$route.params.applicationId);
    this.applicationId = this.$route.params.applicationId;

    this.ApplicationDetails = this.$route.params.ApplicationDetails;
  },
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AgencyExemption/EditStgAgencyApplication.vue